import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getRSODraft = async () => {
  const res = await request.get(
    `/Meter/rso_get_draft`,
    {},
    'При загрузке шаблона РСО произошла ошибка'
  );

  return res;
};

const useRSODraft = (options = {}) => {
  return useQuery(getQueryKeys.rsoDraft(), getRSODraft, options);
};

export default useRSODraft;
